import { CommonModule } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import {
  InsuranceFlowStatus,
  insuranceFlowStatusOrder,
} from 'src/app/enums/insurance-flow/insurance-flow-status.enum';
import { UpdateLeadComponent } from 'src/app/shared/components/update-lead/update-lead.component';
import { IconsModule } from 'src/app/shared/icons/icons.module';
import { Pen2Icon } from 'src/app/shared/icons/pen-2-icon.component';

import { BaseStepperAction } from '../base-action';

@Component({
  selector: 'app-update-lead-stepper-action',
  standalone: true,
  imports: [CommonModule, IconsModule, UpdateLeadComponent, NgbTooltipModule],
  templateUrl: './update-lead.component.html',
})
export class UpdateLeadStepperActionComponent extends BaseStepperAction {
  protected readonly icon = Pen2Icon;

  protected readonly handleActionClick = () => this.openLeadUpdateModal();

  @ViewChild('leadUpdateModal') leadUpdateModal?: UpdateLeadComponent;

  get enabled() {
    const status = this.state?.insuranceFlowData?.status;
    return (
      status !== InsuranceFlowStatus.LEAD_CANCELLED &&
      insuranceFlowStatusOrder[status] <
        insuranceFlowStatusOrder['PENDING_CONTRACT']
    );
  }

  protected get lead() {
    return this.state?.lead;
  }

  protected openLeadUpdateModal(): void {
    if (!this.lead) {
      return;
    }

    this.leadUpdateModal?.openModal();
  }
}
